import { useTranslation } from '@/contexts/i18n-context';
import { useBranding } from '@/outlets/branding-outlet';
interface AppLogoProps {
  className?: string;
}

export function AppLogo({ className }: AppLogoProps) {
  const { logoUrl, logoAltText } = useBranding();
  const { t } = useTranslation();

  return (
    <img src={logoUrl ?? '/logo.svg'} alt={logoAltText ?? t('common.logo')} className={className} />
  );
}
